import * as React from 'react'
import { Switch } from 'react-router'
import { Redirect, Route } from 'react-router-dom'
import CreditCheckPage from './components/creditCheck/CreditCheckPage'
import CreditCheckMessagePage from './components/creditCheckMessage/CreditCheckMessagePage'
import * as routes from './constants/appRoutes'

export default (): JSX.Element => (
    <Switch>
      <Route exact={true} path={routes.messagePage} component={CreditCheckMessagePage}/>
      <Route path={routes.creditCheckForm} component={CreditCheckPage}/>
      <Redirect to={routes.messagePage} />
    </Switch>
)



// WEBPACK FOOTER //
// ./src/Routes.tsx